export class DateUtil {

    static toUtcDate(date: Date): Date {
        const timezoneOffset: number = date.getTimezoneOffset();
        date.setMinutes(-timezoneOffset, 0, 0)

        return date;
    }
}
